import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router, private route: ActivatedRoute) { }

  navigateToSearch(query: string, word: string) {
    console.log('NavigationService.navigateToSearch');
    return this.router.navigate(['/search'], { queryParams: { query, word } });
  }

  navigateToHistory() {
    return this.router.navigateByUrl('/history');
  }

  navigateToFavorite() {
    return this.router.navigateByUrl('/favorite');
  }

  routeData() {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route),
      map((route) => {
        while (route.firstChild) {route = route.firstChild;}
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data),
    );
  }
}
